export class Projection {
    ID: string;
    YEAR: number;
    REVENUE: number;
    SDE_MARGIN: number;
    PROJECTED_SDE: number;
    PRESENT_VALUE_SDE: number;

    static parse(json: any): Projection {
        if (json) {
            const p = new Projection();

            p.ID = json.ID;
            p.YEAR = json.YEAR;
            p.REVENUE = json.REVENUE;
            p.SDE_MARGIN = json.SDE_MARGIN;
            p.PROJECTED_SDE = json.PROJECTED_SDE;
            p.PRESENT_VALUE_SDE = json.PRESENT_VALUE_SDE;

            return p;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Projection> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Projection.parse(j));

        return arr;
    }

}
